import { render } from "./BasicDropdown.vue?vue&type=template&id=166761d8&scoped=true"
import script from "./BasicDropdown.vue?vue&type=script&lang=js"
export * from "./BasicDropdown.vue?vue&type=script&lang=js"

import "./BasicDropdown.vue?vue&type=style&index=0&id=166761d8&lang=scss&scoped=true"
import "./BasicDropdown.vue?vue&type=style&index=1&id=166761d8&lang=scss"

import exportComponent from "/builds/intratone/interface/intratoneinfov4/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166761d8"]])

export default __exports__